module.exports = "/images/tag_4b1c0f.png";